import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	description: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	descriptionIssueTermRefresh: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: 'Bulk action complete',
		id: 'bulk-operations-common.submit-status.flags.success-flag.title',
		description: 'Bulk edit form submission success flag title',
	},
	description: {
		defaultMessage: 'You’ve edited {count, plural, one {# issue} other {# issues}}.',
		id: 'bulk-operations-common.submit-status.flags.success-flag.description',
		description: 'Bulk edit form submission successflag description',
	},
	descriptionIssueTermRefresh: {
		defaultMessage: 'You’ve edited {count, plural, one {# work item} other {# work items}}.',
		id: 'bulk-operations-common.submit-status.flags.success-flag.description-issue-term-refresh',
		description: 'Bulk edit form submission successflag description',
	},
});
export default messages;
